// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__XLNHX","info":"PatientInfo_info__OiUXy"};